import { Grid } from "@mui/material";
import React from "react";
import RequestPointsHeader from "./home/header";
import RequestPointsTabel from "./home/table";


const RequestPoints = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <RequestPointsHeader />
      </Grid>
      <Grid item xs={12}>
        <RequestPointsTabel />
      </Grid>
    </Grid>
  );
};

export default RequestPoints;
